import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { bmxurl } from 'src/globals';
import { getAccess } from 'src/globals';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { booking_returndata } from 'src/types/booking_returndata';
import { BusyService } from '../_services/busy.service';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { AuthService } from '@auth0/auth0-angular';
import { GlobalService } from '../_services/global.service';
import { MenuItem } from 'primeng/api/menuitem';
import { venuesettings_returndata } from 'src/types/venuesettings_returndata';
import { cBookingfee } from 'src/types/bookingfee';
import { bookingfee_returndata } from 'src/types/bookingfee_returndata';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { users_returndata } from 'src/types/user_returndata';

@Component({
  selector: 'app-homepagechoice',
  templateUrl: './homepagechoice.component.html',
  styleUrls: ['./homepagechoice.component.css']
})
export class HomepagechoiceComponent implements OnInit {

  ListBookings: any[];
  ListBookingsGlobal: any[];
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CreateUpdateResponse: any;
  DisabledListResource: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  selectedItems: any;
  BookingDate: Date;
  PreviousBookingDate: Date;
  hubConnection: HubConnection;
  httpResponse: any;
  navSubscription: Subscription = null;
  bookingsInProgress: number = 0;
  totalBookingsToday: number = 0;
  inProgress: boolean = false;

  bcItems: MenuItem[];
  home: MenuItem;
  PreviousHubs: string[] = [];
  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  CurrencySymbol: string = "-";

  searchCriteria: string = "";
  //PageLinks: any;
  //currentPageIndex: number = 4;

  cols: any[];

  //@ViewChild('resourceTable') dataTable: any;
  //@ViewChild('table', { static: true }) dataTable!: any;

  screenwidth: number = window.innerWidth;

    constructor(
      private http: HttpClient, 
      private appComp: AppComponent, 
      private router: Router, 
      private messageService: MessageService, 
      private busyService: BusyService,
      private auth: AuthService,
      private globalService: GlobalService,
      private route: ActivatedRoute) {
        
      let userid = localStorage.getItem("SmartUserID");
  
      this.http.get(bmxurl + "User/" + userid).subscribe(response => {
        this.httpResponse =  (response as users_returndata)
        if(this.httpResponse.succeeded)
        {
          let user = this.httpResponse.data;
  
          if(getAccess("HOME", user)){
            this.AccessAllowed = true;
          }
  
          this.CompletedLoading = true;
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
      });
    }

    ngOnInit(): void {
  
    this.globalService.setSmallScreenMenu(false);

    addEventListener("resize", (event) => {
      this.screenwidth = window.innerWidth;
    });

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");
    
    this.auth.getAccessTokenSilently().subscribe(tokenReturned => {
      this.hubConnection = new HubConnectionBuilder()
      .withUrl(environment.servicestarget + "/venue/" + this.VenueID, { 
      accessTokenFactory: () => tokenReturned 
    }).build();

    //Get Settings and put them in Local Storage
    this.http.get(bmxurl + "venuesettings/" + this.VenueID).subscribe(response => {
      this.httpResponse =  (response as venuesettings_returndata)
      if(this.httpResponse.succeeded)
      {

        let menuItems: MenuItem[];

        let userid = localStorage.getItem("SmartUserID");

        this.http.get(bmxurl + "User/" + userid).subscribe(response => {
          this.httpResponse = (response as any)
          if(this.httpResponse.succeeded)
          {
            let user = this.httpResponse.data;
            
            let Home = localStorage.getItem("ChosenHomePage") == null ? "/home" : "/" + localStorage.getItem("ChosenHomePage")!;

            menuItems =
                [
                {label: 'Home', icon: 'pi pi-home', routerLink: [Home]},
                {label: 'Make A Booking', icon: 'pi pi-calendar', routerLink: ['/booking/0']},
                {label: 'Quick Book', icon: 'pi pi-telegram', routerLink: ['/booking/0/true']},
                {
                  label: 'Sell',
                  items: [
                    {label: 'Bookings', icon: 'pi pi-calendar', routerLink: ['/booking/0']},
                    {label: 'Events', icon: 'pi pi-ticket', routerLink: ['/event']}, 
                    {label: 'Gift Vouchers', icon: 'pi pi-ticket', routerLink: ['/sellavoucher']},
                    {label: 'Memberships', icon: 'pi pi-users', routerLink: ['/sellmemberships']},
                    {label: 'Scheduled Sessions', icon: 'pi pi-users', routerLink: ['/sellscheduledsession']},        
                    {label: 'Till', icon: 'pi pi-shopping-bag', routerLink: ['/till']},
                  ],
                },
                {
                  label: 'Views',
                  items: [
                    {label: 'At a Glance', icon: 'pi pi-eye', routerLink: ['/ataglance']},
                    {label: 'Bookings Created Today', icon: 'pi pi-check-circle', routerLink: ['/home']},
                    {label: 'Bookings List', icon: 'pi pi-align-justify', routerLink: ['/bookinglist']},
                    {label: 'Party List', icon: 'pi pi-align-justify', routerLink: ['/partylist']},
                    {label: 'Daysheet', icon: 'pi pi-align-left', routerLink: ['/daysheetstyle1']},
                  ],
                },
                {
                  label: 'Booking Questions',
                  items: [
                      
                      {label: 'Booking Questions', icon: 'pi pi-question-circle', routerLink: ['/bookingquestions']},
                      {label: 'Booking Questionnaires', icon: 'pi pi-list', routerLink: ['/bookingquestionnaire']},
                  ]
                },
                {
                  label: 'Emails & Confirmations',
                  items: [
                      {label: 'Confirmations', icon: 'pi pi-at', routerLink: ['/confirmations']},
                      {label: 'Email Templates', icon: 'pi pi-envelope', routerLink: ['/emailtemplates']},
                  ]
                },
                {
                  label: 'Event Settings',
                  items: [
                    {label: 'Admissions', icon: 'pi pi-user', routerLink: ['/admission']},
                    {label: 'Confirmations', icon: 'pi pi-at', routerLink: ['/confirmations']},
                    {label: 'Deposit Policies', icon: 'pi pi-wallet', routerLink: ['/depositpolicies']},
                    {label: 'Events', icon: 'pi pi-ticket', routerLink: ['/event']}, 
                    {label: 'Tags', icon: 'pi pi-tags', routerLink: ['/tag']},
                    {label: 'Warnings', icon: 'pi pi-info-circle', routerLink: ['/warnings'], visible: true},
                  ]
                },
                {
                  label: 'Financial',
                  items: [
                      {label: 'Cash up', icon: 'pi pi-print', routerLink: ['/cashuplist']},
                      {label: 'Reports', icon: 'pi pi-align-justify', routerLink: ['/reportspage']},
                  ]
                },
                {
                  label: 'Gift Vouchers',
                  items: [
                      {label: 'Sell Gift Vouchers', icon: 'pi pi-ticket', routerLink: ['/sellavoucher']},
                      {label: 'Manage Gift Vouchers', icon: 'pi pi-shopping-bag', routerLink: ['/voucherlist']}, 
                  ]
                },
                {
                  label: 'Memberships',
                  items: [
                    {label: 'Sell Memberships', icon: 'pi pi-users', routerLink: ['/sellmemberships']},
                    {label: 'Manage Memberships', icon: 'pi pi-users', routerLink: ['/membershiplist']},
                    {label: 'Membership Set-up', icon: 'pi pi-users', routerLink: ['/memberships']},
                  ],
                },
                {
                  label: 'Package Settings',
                  items: [
                    {label: 'Admissions', icon: 'pi pi-user', routerLink: ['/admission']},
                    {label: 'Classes', icon: 'pi pi-users', routerLink: ['/class']},
                    {label: 'Confirmations', icon: 'pi pi-at', routerLink: ['/confirmations']},
                    {label: 'Deposit Policies', icon: 'pi pi-wallet', routerLink: ['/depositpolicies']},
                    {label: 'Extras', icon: 'pi pi-star', routerLink: ['/extra']},
                    {label: 'Multi Package Extras', icon: 'pi pi-clone', routerLink: ['/multipackageextras']},
                    {label: 'Package', icon: 'pi pi-box', routerLink: ['/package']},
                    //{label: 'Package Add-Ons', icon: 'pi pi-arrow-circle-up', routerLink: ['/packageaddons'], visible:  true},
                    {label: 'Package Groups', icon: 'pi pi-clone', routerLink: ['/packagegroups']},
                    {label: 'Package Rules', icon: 'pi pi-tag', routerLink: ['/packagerule']},
                    {label: 'Upgrades', icon: 'pi pi-arrow-up', routerLink: ['/upgrades']},
                    //{label: 'Add-Ons', icon: 'pi pi-arrow-circle-up', routerLink: ['/admissionbasedupgrades']},
                    {label: 'Tags', icon: 'pi pi-tags', routerLink: ['/tag']},
                    {label: 'Warnings', icon: 'pi pi-info-circle', routerLink: ['/warnings'], visible: true},

                  ],
                },
                {
                  label: 'Resources',
                  items: [
                    {label: 'Classes', icon: 'pi pi-users', routerLink: ['/class']},
                    {label: 'Resources', icon: 'pi pi-clone', routerLink: ['/resource']},
                    {label: 'Closings and Adjustments', icon: 'pi pi-ban', routerLink: ['/resourceclosings']},
                    {label: 'Resource Groups', icon: 'pi pi-sitemap', routerLink: ['/resourcegroupnames']},
                  ],
                },
                {
                  label: 'Scheduled Sessions',
                  items: [
                    {label: 'Sell Scheduled Sessions', icon: 'pi pi-users', routerLink: ['/sellscheduledsession']},
                    {label: 'Manage Sessions', icon: 'pi pi-calendar', routerLink: ['/scheduledsessionlist']},
                    {label: 'Session Calendar', icon: 'pi pi-calendar', routerLink: ['/scheduledsessioncalendar']},
                    {label: 'Set-up Sessions', icon: 'pi pi-users', routerLink: ['/scheduledsessions']},
                  ],
                },
                {
                  label: 'Tasks',
                  items: [
                    {label: 'Task Types', icon: 'pi pi-paperclip', routerLink: ['/tasktypelist']},
                    {label: 'Task Status List', icon: 'pi pi-list', routerLink: ['/testtask']},
                  ],
                },
                {
                  label: 'Till',
                  items: [
                    {label: 'Till', icon: 'pi pi-shopping-bag', routerLink: ['/till']},
                    {label: 'Till Departments', icon: 'pi pi-table', routerLink: ['/tilldepartments']},
                  ],
                },
                {
                  label: 'Venue Management',
                  items: [
                      {label: 'Booking Fees', icon: 'pi pi-money-bill', routerLink: ['/bookingfee']},
                      {label: 'Cash up', icon: 'pi pi-print', routerLink: ['/cashuplist']},
                      {label: 'Customer Portal', icon: 'pi pi-id-card', routerLink: ['/customerportal']},
                      {label: 'Discounts', icon: 'pi pi-arrow-circle-down', routerLink: ['/discounts'], visible:  true},
                      {label: 'Reports', icon: 'pi pi-align-justify', routerLink: ['/reportspage']},
                      {label: 'Link Manager', icon: 'pi pi-link', routerLink: ['/linkmanager']},        
                      {label: 'Tags', icon: 'pi pi-tags', routerLink: ['/tag']},
                      {label: 'Terms & Conditions', icon: 'pi pi-check-square', routerLink: ['/terms']},
                      {label: 'Time Sets', icon: 'pi pi-clock', routerLink: ['/timesets']},
                      {label: 'User Management', icon: 'pi pi-user', routerLink: ['/users']},
                      {label: 'Venue Closings', icon: 'pi pi-lock', routerLink: ['/venueclosings']},
                      {label: 'Venue Settings', icon: 'pi pi-cog', routerLink: ['/venuesettings']}, 
                      {label: 'Warnings', icon: 'pi pi-info-circle', routerLink: ['/warnings'], visible: true},
                      {label: 'Integrations', icon: 'pi pi-th-large', routerLink: ['/integrations'], visible: true},
                  ]
                },
                {
                  label: 'Waivers',
                  items: [
                      {label: 'Manage Statement of Risk', icon: 'pi pi-file', routerLink: ['/statementofrisk']},
                      //{label: 'Manage Waivers', icon: 'pi pi-file', routerLink: ['/managewaivers']},
                  ]
                },
                {label: 'Dashboard (BETA)', icon: 'pi pi-lock', routerLink: ['/altfrontpage']}
              
                
            ];

            this.globalService.setMenuItems(menuItems);  

            this.globalService.setBCItem(['Home','/home']);

            let UseCounters = localStorage.getItem("UseCounter")
            this.globalService.setUseCounters(UseCounters);

            if(Home != null && Home != "")
            {
              this.router.navigate(["/" + Home]);
            }
                
          }
        }, error => {
          this.messageService.add({ severity: 'error', summary: 'Unable to get User' });
        });

        //Set Venue Settings ID
        localStorage.setItem("VenueSettingsID", this.httpResponse.data.id);

        this.httpResponse.data.venueSettings.forEach(element => {
          localStorage.setItem(element.name, element.value);
        });

        if(localStorage.getItem("VoucherEmailTemplate") == null || localStorage.getItem("VoucherEmailTemplate") == "null")
        {
          localStorage.setItem("VoucherEmailTemplate", "");
        }

        this.CurrencySymbol = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;
      }
      else{
        //this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
      }
    }, error => {
      this.messageService.add({ severity: 'error', summary: 'Unable to get Venue Settings' });
    });

    });

    // this.http.get(bmxurl + "bookingfee/" + this.VenueID).subscribe(response => {
    //   this.httpResponse = (response as bookingfee_returndata)
    //   if (this.httpResponse.succeeded)
    //   {
    //     if(this.httpResponse.data != null)
    //     {
    //       let BookingFee: cBookingfee = {
    //         id: (this.httpResponse.data as cBookingfee).id,
    //         venueid: (this.httpResponse.data as cBookingfee).venueid,
    //         disabled: (this.httpResponse.data as cBookingfee).disabled,
    //         bfid: (this.httpResponse.data as cBookingfee).bfid,
    //         name: (this.httpResponse.data as cBookingfee).name,
    //         isdefault: (this.httpResponse.data as cBookingfee).isdefault,
    //         bfpublicapply: (this.httpResponse.data as cBookingfee).bfpublicapply,
    //         bfadminapply: (this.httpResponse.data as cBookingfee).bfadminapply,
    //         bfpublicshowtext: (this.httpResponse.data as cBookingfee).bfpublicshowtext,
    //         bfpublictext: (this.httpResponse.data as cBookingfee).bfpublictext,
    //         bfpublictype: (this.httpResponse.data as cBookingfee).bfpublictype,
    //         bfadmintype: (this.httpResponse.data as cBookingfee).bfadmintype,
    //         bfpublicfee: (this.httpResponse.data as cBookingfee).bfpublicfee,
    //         bfpublicmin: (this.httpResponse.data as cBookingfee).bfpublicmin,
    //         bfpublicmax: (this.httpResponse.data as cBookingfee).bfpublicmax,
    //         bfadminfee: (this.httpResponse.data as cBookingfee).bfadminfee,
    //         bfadminmin: (this.httpResponse.data as cBookingfee).bfadminmin,
    //         bfadminmax: (this.httpResponse.data as cBookingfee).bfadminmax,
    //         bookingfeeappliestomemberspublic: (this.httpResponse.data as cBookingfee).bookingfeeappliestomemberspublic,
    //         bookingfeeappliedonmembershippurchasespublic: (this.httpResponse.data as cBookingfee).bookingfeeappliedonmembershippurchasespublic,
    //         bookingfeeappliestomembersadmin: (this.httpResponse.data as cBookingfee).bookingfeeappliestomembersadmin,
    //         bookingfeeappliedonmembershippurchasesadmin: (this.httpResponse.data as cBookingfee).bookingfeeappliedonmembershippurchasesadmin,
    //       };

    //       localStorage.setItem("VenueBookingFee", JSON.stringify(BookingFee));
    //     }
    //   }
    //   else
    //   {
    //     this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Booking Fee'});
    //   }
    // }, error => {
    //   this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting Booking Fee, error:' + error.messages[0]});
    // });

    }

}
